import { Route, Redirect, Switch } from 'react-router-dom';

import { PaymentMethod } from '../containers/settings/payment-method';
import { ROUTE_PATH } from './route-paths';
import useAuth from '../hooks/utils/useAuth';
import BrowseByTopic from '../containers/browse-by-topic/browse-by-topic';
import BrowseResources from '../containers/browse-resources/browse-resources';
import BrowseExperiences from '../containers/browse-experiences/browse-experiences';
import BrowsePeers from '../containers/browse-peers/browse-peers';
import ViewCollection from '../containers/view-collection/view-collection';
import PrimaryLandingPage from '../containers/home-page/home-page';
import { PeerDetailsPage } from '../containers/peer-details/peer-details';
import PeerListeners from '../containers/peer-listeners/peer-listeners';
import { SupportPage } from '../containers/support';
import FAQsPage from '../containers/landing-page/faq-page';
import { TopicPreferencesPage } from '../containers/my-topics/topic-preferences-page';
import MyFavoritesPage from '../containers/my-favorites/my-favorites';
import { ProfileSettingsPage } from '../containers/settings-pages/profile-settings-page';
import { MembershipSettingsPage } from '../containers/settings-pages/membership-settings-page';
import { InfoSettingsPage } from '../containers/settings-pages/info-settings-page';

export const MwaRouter = () => {
  const { user } = useAuth();
  const isUserSuspended = user?.status === 'suspended';

  const callerRoleRoutes = [
    {
      path: ROUTE_PATH.HOME,
      component: PrimaryLandingPage,
    },
    {
      path: ROUTE_PATH.TOPIC_PREFERENCES,
      component: TopicPreferencesPage,
    },

    {
      path: ROUTE_PATH.SUPPORT,
      component: SupportPage,
    },
    {
      path: ROUTE_PATH.FAQS,
      component: FAQsPage,
    },
    {
      path: `${ROUTE_PATH.BROWSE_TOPIC}/:tag_group_key`,
      component: BrowseByTopic,
    },
    {
      path: ROUTE_PATH.BROWSE_RESOURCES,
      component: BrowseResources,
    },
    {
      path: ROUTE_PATH.BROWSE_STORIES,
      component: BrowseExperiences,
    },
    {
      path: ROUTE_PATH.BROWSE_PEERS,
      component: BrowsePeers,
    },
    {
      path: ROUTE_PATH.BROWSE_PEER_LISTENERS,
      component: PeerListeners,
    },
    {
      path: ROUTE_PATH.MY_FAVORITES,
      component: MyFavoritesPage,
    },
    {
      path: `${ROUTE_PATH.COLLECTION}/:collection_id`,
      component: ViewCollection,
    },
    {
      path: ROUTE_PATH.SETTINGS_PROFILE,
      component: ProfileSettingsPage,
    },
    {
      path: ROUTE_PATH.SETTINGS_MEMBERSHIP,
      component: MembershipSettingsPage,
    },
    {
      path: ROUTE_PATH.SETTINGS_INFO,
      component: InfoSettingsPage,
    },
  ];

  // Our backend returns a 403 for suspended users trying to access a single listener, and they aren't able to schedule or make calls, so we don't show these routes for suspended users
  if (!isUserSuspended) {
    callerRoleRoutes.push({
      path: ROUTE_PATH.PEER_DETAILS,
      component: PeerDetailsPage,
    });
  }

  return (
    <Switch>
      {callerRoleRoutes.map(({ path, component }) => (
        <Route key={path} exact path={path} component={component} />
      ))}
      {!user?.onUnlimitedPlan && <Route exact path={ROUTE_PATH.PAYMENT} component={PaymentMethod} />}
      <Route render={() => <Redirect to={ROUTE_PATH.HOME} />} />
    </Switch>
  );
};

export const NonActiveMwaRouter = () => {
  return (
    <Switch>
      <Route exact path="*" render={() => <Redirect to={ROUTE_PATH.WELCOME_PAGE} />} />
    </Switch>
  );
};
